import VaultConfig from './config'

export default {
  vaultPin: '',
  vaultMnemonic: sessionStorage.getItem('vault.vaultMnemonic') || '',
  vault: null,
  vaultWallet: null,
  vaultId: localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_ID) || '',
  vaultSalt: localStorage.getItem(VaultConfig.LOCAL_STATES.VAULT_SALT) || '',
  authServerAuthToken: localStorage.getItem(VaultConfig.LOCAL_STATES.AUTH_SERVER_TOKEN) || '',
}
